/**
 * Media Gallery
 * - Category chip filtering
 * - Lightbox on item click
 */
(function () {
  'use strict';

  // ── Chip filtering ─────────────────────
  function initFilter(filterEl) {
    var key     = filterEl.getAttribute('data-chips-filter');
    var gallery = filterEl.closest('.block-gallery');
    if (!gallery) return;

    var items   = gallery.querySelectorAll('.media-gallery__item');
    var chips   = filterEl.querySelectorAll('.chip');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        // Update active chip
        chips.forEach(function (c) { c.classList.remove('chip--active'); });
        chip.classList.add('chip--active');

        var filter = chip.getAttribute('data-filter');

        items.forEach(function (item) {
          var cat = item.getAttribute('data-category') || '';
          if (filter === '*' || cat === filter) {
            item.classList.remove('is-hidden');
            item.hidden = false;
          } else {
            item.classList.add('is-hidden');
            item.hidden = true;
          }
        });
      });
    });
  }

  // ── Lightbox ───────────────────────────
  function initLightbox(gallery) {
    // Skip inside the block editor: this frontend script also runs there so
    // ACF block previews look/behave correctly, but the lightbox is a
    // full-viewport fixed overlay — opening it blocks the entire editor UI
    // (toolbar, sidebar, everything) with no way out other than knowing to
    // find its tiny close button. Not worth the risk for an editor preview.
    if (document.body.classList.contains('block-editor-page')) return;

    var items    = gallery.querySelectorAll('.media-gallery__item');
    var lightbox = gallery.parentElement
      ? gallery.parentElement.querySelector('.media-gallery__lightbox')
      : null;

    // Fall back to document-level lightbox (same block section)
    if (!lightbox) {
      var section = gallery.closest('section');
      lightbox = section ? section.nextElementSibling : null;
      if (lightbox && !lightbox.classList.contains('media-gallery__lightbox')) {
        lightbox = null;
      }
    }

    if (!lightbox) return;

    var lbImg        = lightbox.querySelector('.media-gallery__lightbox-img');
    var lbVideoWrap  = lightbox.querySelector('.media-gallery__lightbox-video');
    var lbVideoFrame = lbVideoWrap ? lbVideoWrap.querySelector('iframe') : null;
    var lbClose      = lightbox.querySelector('.media-gallery__lightbox-close');
    var lbBackdrop   = lightbox.querySelector('.media-gallery__lightbox-backdrop');

    function openLightbox(src, alt) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      lbImg.hidden = false;
      if (lbVideoWrap) lbVideoWrap.hidden = true;
      if (lbVideoFrame) lbVideoFrame.src = '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function openLightboxVideo(embedUrl) {
      if (!lbVideoWrap || !lbVideoFrame) return;
      lbImg.hidden = true;
      lbImg.src = '';
      lbVideoFrame.src = embedUrl;
      lbVideoWrap.hidden = false;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lbImg.src = '';
      lbImg.hidden = false;
      // Clearing the iframe src (rather than just hiding it) actually stops
      // playback — leaving it set would keep the video running silently
      // behind the closed modal.
      if (lbVideoFrame) lbVideoFrame.src = '';
      if (lbVideoWrap) lbVideoWrap.hidden = true;
      document.body.style.overflow = '';
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var videoEmbed = item.getAttribute('data-video-embed');
        if (videoEmbed) {
          openLightboxVideo(videoEmbed);
          return;
        }
        var src = item.getAttribute('data-src');
        var alt = item.getAttribute('data-alt') || '';
        if (src) openLightbox(src, alt);
      });
    });

    if (lbClose)    lbClose.addEventListener('click', closeLightbox);
    if (lbBackdrop) lbBackdrop.addEventListener('click', closeLightbox);

    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function init() {
    // Filters
    document.querySelectorAll('[data-chips-filter="gallery"]').forEach(initFilter);

    // Lightboxes
    document.querySelectorAll('.media-gallery__grid').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
